var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _vm.isActiveStep(_vm.step)
    ? _c(
        "div",
        { staticClass: "solutionguide__step-wrapper" },
        [
          _c("p", { staticClass: "lead" }, [
            _c("strong", [
              _vm._v(
                _vm._s(
                  _vm.$t("result.headline", {
                    segment: _vm.$store.state.segment.name,
                    application: _vm.$store.state.application.name,
                    component: _vm.$store.state.component.name,
                  })
                )
              ),
            ]),
          ]),
          _vm._v(" "),
          _c("result-table", { attrs: { rows: _vm.mainTableRows } }),
          _vm._v(" "),
          _vm.additionalTableRows.length > 0
            ? _c(
                "div",
                [
                  _c(
                    "div",
                    {
                      staticClass:
                        "solutionguide__result-tblfooter solutionguide__result-tblfooter--top",
                    },
                    [
                      _c(
                        "div",
                        {
                          staticClass: "button-wrapper right spacer--top-none",
                        },
                        [
                          _vm.$store.state.ctalink &&
                          _vm.$store.state.ctalink.url
                            ? _c(
                                "GlobalButton",
                                {
                                  attrs: {
                                    theme: "brand",
                                    icon: "calendar",
                                    href: _vm.$store.state.ctalink.url,
                                    target: _vm.$store.state.ctalink.target,
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("result.button.cta")))]
                              )
                            : _vm._e(),
                        ],
                        1
                      ),
                    ]
                  ),
                  _vm._v(" "),
                  _vm.isMobile
                    ? [
                        _c(
                          "global-accordion",
                          {
                            attrs: {
                              accordionType: "3",
                              theme: "theme--grey",
                              open: _vm.isAccordionOpen,
                            },
                            on: { toggleAccordion: _vm.toggleAccordion },
                          },
                          [
                            _c("template", { slot: "header" }, [
                              _vm._v(
                                "\n                    " +
                                  _vm._s(
                                    _vm.$t("result.headline2", {
                                      segment: _vm.$store.state.segment.name,
                                      application:
                                        _vm.$store.state.application.name,
                                      component:
                                        _vm.$store.state.component.name,
                                    })
                                  ) +
                                  "\n                "
                              ),
                            ]),
                            _vm._v(" "),
                            _c(
                              "template",
                              { slot: "body" },
                              [
                                _c("result-table", {
                                  attrs: { rows: _vm.additionalTableRows },
                                }),
                              ],
                              1
                            ),
                          ],
                          2
                        ),
                      ]
                    : [
                        _c("p", { staticClass: "lead" }, [
                          _c("strong", [
                            _vm._v(
                              _vm._s(
                                _vm.$t("result.headline2", {
                                  segment: _vm.$store.state.segment.name,
                                  application:
                                    _vm.$store.state.application.name,
                                  component: _vm.$store.state.component.name,
                                })
                              )
                            ),
                          ]),
                        ]),
                        _vm._v(" "),
                        _c("result-table", {
                          attrs: { rows: _vm.additionalTableRows },
                        }),
                      ],
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass:
                "solutionguide__result-tblfooter solutionguide__result-tblfooter--bottom",
            },
            [
              _c("div", { staticClass: "solutionguide__result-line" }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "button-wrapper full-width--xs" },
                [
                  _c(
                    "a",
                    {
                      staticClass: "solutionguide__restart",
                      attrs: { href: "#" },
                      on: { click: _vm.restart },
                    },
                    [_vm._v(_vm._s(_vm.$t("result.button.restart")))]
                  ),
                  _vm._v(" "),
                  _vm.$store.state.ctalink && _vm.$store.state.ctalink.url
                    ? _c(
                        "GlobalButton",
                        {
                          attrs: {
                            theme: "brand",
                            icon: "calendar",
                            href: _vm.$store.state.ctalink.url,
                            target: _vm.$store.state.ctalink.target,
                          },
                        },
                        [_vm._v(_vm._s(_vm.$t("result.button.cta")))]
                      )
                    : _vm._e(),
                ],
                1
              ),
            ]
          ),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }